import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';

@Component({
  selector: 'app-load-watch-generator-health',
  templateUrl: './load-watch-generator-health.component.html',
  styleUrls: ['./load-watch-generator-health.component.css']
})

export class LoadWatchGeneratorHealthComponent implements OnInit {

  generatorHealth: any;

  searchForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    strIMEI: new FormControl('')
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.parent?.params['id'];

    this.searchForm.patchValue({
      strIMEI: id
    })

    this.fetchData();

  }

  fetchData = async (showLoading: boolean = true) => {
    let model = this.searchForm.value;

    if (showLoading) {
      this._other.Showspinner()
    }

    let res = JSON.parse((await axios.post(`LoadWatch_AnalyzeGeneratorHealth`, this._other.stringNumberToNumber(model))).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.generatorHealth = res;


  }

  getImbalanceStatus(value: number): string {
    if (value == null || value < 0) {
      return '';
    }

    if (value <= 5) {
      return 'نرمال';
    } else if (value <= 10) {
      return 'هشدار';
    } else if (value <= 15) {
      return 'نامطلوب';
    } else {
      return 'بحرانی';
    }
  }

}
